// --------------------------------------------------------------------------
// gettingHereMap.js
// --------------------------------------------------------------------------
// Uses Google Maps API to create map for getting here background
// --------------------------------------------------------------------------

EC.gettingHereMap = function () {

    'use strict';

    function init () {
        let map = new google.maps.Map(document.getElementById('js-getting-here-map'), {
            center: new google.maps.LatLng(53.992987, -1.539931),
            zoom: 15,
            disableDefaultUI: true,
            gestureHandling: 'none',
            scrollwheel: false,
            styles: [
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "lightness": 100
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#C6E2FF"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#C5E3BF"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#D1D1B8"
                        }
                    ]
                }
            ]
        });
    }

    return {
        init: init
    };

}();